var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components'; // Currently image only appears as top-cap
// Takes height prop with default to 200px

var SharpCardImage = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  height: ", ";\n  object-fit: cover;\n  padding: 0;\n  margin-top: -1rem;\n  width: 100%;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n"])), function (props) {
  return props.height;
});
SharpCardImage.displayName = 'Card.Image';

var CardImage = function CardImage(_ref) {
  var alt = _ref.alt,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '200px' : _ref$height,
      src = _ref.src;
  return /*#__PURE__*/React.createElement(SharpCardImage, {
    alt: alt,
    className: "scl-card-image ".concat(className),
    "data-test-id": "scl-card-image",
    height: height,
    src: src
  });
};

CardImage.propTypes = {
  /**
   Required alternate text used for accessibility and when image fails
  */
  alt: string,

  /**
   Optional className to include in rendered component
  */
  className: string,

  /**
   Optional to control image height
  */
  height: string,

  /**
   Required url for image
  */
  src: string
};
export default CardImage;